module.exports = __webpack_public_path__ + "static/sabine-mobile-4bcef74d12c1640bfcc7f3710608bb31.jpg";